import { html, ref, when } from '@microsoft/fast-element';
import type { IndividualProjectVppas } from './individual-projects-vppas';
import {PRODUCT_TYPE, PROFILE_RIGHTS} from '../../../../utils';
import {plusIcon} from "../../../../styles";
import {VppaManagement} from "../../seller-dashboard-components/vppa-management/vppa-management";
export enum INDIVIDUAL_PROJECTS_CONTRACTS_TABS {
  VPPA_TAB = 'vppaTab',
  VPPA_PANEL = 'vppaPanel',
  PPA_TAB = 'ppaTab',
  PPA_PANEL = 'ppaPanel',
  RECS_TAB = 'recsTab',
  RECS_PANEL = 'recsPanel',
}
export const IndividualProjectVppasTemplate = html<IndividualProjectVppas>`
  <div class="container">
    <zero-tabs>
    ${when(
      (x) => !x.companyService.isNonSefParticipantAgreement(),
      html<IndividualProjectVppas>`
        <zero-tab
          slot="tab"
          id=${INDIVIDUAL_PROJECTS_CONTRACTS_TABS.VPPA_TAB}
          @click=${(x) => x.allVppaGrid()}
        >
          VPPAs
        </zero-tab>
      `
    )}
      
       <zero-tab
        slot="tab"
        id=${INDIVIDUAL_PROJECTS_CONTRACTS_TABS.PPA_TAB}
        @click=${(x) => x.allPpaGrid()}
      >
        PPAs
      </zero-tab> 
       

      <zero-tab
        slot="tab"
        id=${INDIVIDUAL_PROJECTS_CONTRACTS_TABS.RECS_TAB}
        @click=${(x) => x.allRecsGrid()}
      >
        RECs
      </zero-tab>

      ${when(
        (x) => !x.companyService.isNonSefParticipantAgreement(),
        html<IndividualProjectVppas>`
          <zero-tab-panel
            slot="tabpanel"
            class="full-height-tab"
            id=${INDIVIDUAL_PROJECTS_CONTRACTS_TABS.VPPA_PANEL}
          >
            <individual-projects-vppas-grid
              class="grid-styles"
              only-template-col-defs
              sideBar=""
              rowSelection="single"
              :gridProductType=${(x) => PRODUCT_TYPE.VIRTUAL_PPA}
              :productType="${(x) => x.productType}"
              ${ref('contractGridVppa')}
            ></individual-projects-vppas-grid>
          </zero-tab-panel>
        `
      )}

       <zero-tab-panel
        slot="tabpanel"
        class="full-height-tab"
        id=${INDIVIDUAL_PROJECTS_CONTRACTS_TABS.PPA_PANEL}
      >
        <individual-projects-vppas-grid
          class="grid-styles"
          only-template-col-defs
          sideBar=""
          rowSelection="single"
          :gridProductType=${(x) => PRODUCT_TYPE.PHYSICAL_PPA}
          :productType="${(x) => x.productType}"
          ${ref('contractGridPpa')}
        ></individual-projects-vppas-grid>
      </zero-tab-panel> 

      <zero-tab-panel
        slot="tabpanel"
        class="full-height-tab"
        id=${INDIVIDUAL_PROJECTS_CONTRACTS_TABS.RECS_PANEL}
      >
        <individual-projects-vppas-grid
          class="grid-styles"
          only-template-col-defs
          sideBar=""
          rowSelection="single"
          :gridProductType=${(x) => PRODUCT_TYPE.RECS}
          :productType="${(x) => x.productType}"
          ${ref('contractGridRec')}
        ></individual-projects-vppas-grid>
      </zero-tab-panel>
      
      <tab-buttons slot="end">
        <zero-button
          class="buttons-padding"
          slot="buttons"
          appearance="tab-primary"
          @click=${(x) => x.downloadGridCsv()}
        >
          Download
        </zero-button>
          ${when(
                  (x) => x.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.UPSERT_VPPA),
                  html<IndividualProjectVppas>`
            <zero-button
              slot="buttons"
              id="newContract"
              appearance="tab-primary"
              @click=${(x) => x.openVppaModal()}
            >
              ${plusIcon('start')} New Contract
            </zero-button>
          `
          )}
    </zero-tabs>
    
  </div>
`;
